import Glide from "@glidejs/glide";
import { forAllCallback } from "kwp-core/scripts/utils/helpers";

export default () => {
    forAllCallback(".content-block.content-block--slider", (el) => {
        const glideEl = el.querySelector(".glide");
        let options = {
            type: "carousel",
        };

        const queryString = window.location.search;

        const urlParams = new URLSearchParams(queryString);
        const selectedFunction = urlParams.get("room_function");

        if (selectedFunction) {
            const slides = Array.from(el.querySelectorAll(".glide__slide"));

            const matchingSlide = slides.findIndex((slide) => {
                return (
                    slide.getAttribute("data-selected-function") ===
                    selectedFunction
                );
            });

            if (matchingSlide) {
                options = {
                    ...options,
                    startAt: matchingSlide,
                };
            }
        }

        const glide = new Glide(glideEl, options);
        glide.mount();
    });
};
